import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getCoinHeistGameDailyStatisticsService,
  getDashboardReportService,
  getHiloGameDailyStatisticsService,
  getLimboGameDailyStatisticsService,
  getMineGameDailyStatisticsService,
  getPlinkoGameDailyStatisticsService,
  getDiceGameDailyStatisticsService,
  getCoinFlipGameDailyStatisticsService,
  getKenoGameDailyStatisticsService,
  getRouletteGameDailyStatisticsService
} from 'network/services/dashboard.service'

export const fetchDashboardReport = createAsyncThunk(
  'fetch/DashboardReport',
  async (data, thunkApi) => {
    try {
      const res = await getDashboardReportService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchPlinkoGameDailyStatisticsReport = createAsyncThunk(
  'fetch/plinkoGameDailyStatistics',
  async (data, thunkApi) => {
    try {
      const res = await getPlinkoGameDailyStatisticsService(data)
      console.log('response of plinko---------->', res)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchLimboGameDailyStatisticsReport = createAsyncThunk(
  'fetch/LimboGameDailyStatistics',
  async (data, thunkApi) => {
    try {
      const res = await getLimboGameDailyStatisticsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchMineGameDailyStatisticsReport = createAsyncThunk(
  'fetch/MineGameDailyStatistics',
  async (data, thunkApi) => {
    try {
      const res = await getMineGameDailyStatisticsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchCoinHeistGameDailyStatisticsReport = createAsyncThunk(
  'fetch/CoinHeistGameDailyStatistics',
  async (data, thunkApi) => {
    try {
      const res = await getCoinHeistGameDailyStatisticsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchHiloGameDailyStatisticsReport = createAsyncThunk(
  'fetch/HiloGameDailyStatistics',
  async (data, thunkApi) => {
    try {
      const res = await getHiloGameDailyStatisticsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
export const fetchDiceGameDailyStatisticsReport = createAsyncThunk(
  'fetch/DiceGameDailyStatistics',
  async (data, thunkApi) => {
    try {
      const res = await getDiceGameDailyStatisticsService(data)
      console.log('response-------->', res)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchCoinFlipGameDailyStatisticsReport = createAsyncThunk(
  'fetch/CoinFlipGameDailyStatistics',
  async (data, thunkApi) => {
    try {
      const res = await getCoinFlipGameDailyStatisticsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchKenoGameDailyStatisticsReport = createAsyncThunk(
  'fetch/KenoGameDailyStatistics',
  async (data, thunkApi) => {
    try {
      const res = await getKenoGameDailyStatisticsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchRouletteGameDailyStatisticsReport = createAsyncThunk(
  'fetch/RouletteGameDailyStatistics',
  async (data, thunkApi) => {
    try {
      const res = await getRouletteGameDailyStatisticsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
